import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as routeSelectors from "src/app/state/route/route.selector";
import { selectWorldReady } from "src/app/state/world/world.selector";
import { flyers } from "../world/blueprints/flyer/flyer.service";
import { worldActions } from "src/app/state/world/world.actions";
import { InstanceService } from "../world/instance-service/instance.service";
import {OfflineImageService} from "./events/offline-image.service";
import {OnlineImageService} from "./events/online-image.service";
import {OnlineTimerService} from "./events/online-timer.service";
import { TestAvatarsService } from "./events/test-avatars.service";
import { TestSpiralMakerService } from "./events/test-spiral-maker.service";
import { EventsBlueprint } from "./events/events-blueprint";
import {SurfaceGridTestService} from "./events/surface-grid-test.service";
import {IsolateEntityService} from "./events/isolate-entity.service";

const activeFlyers = flyers;

@Injectable({
  providedIn: "root",
})
export class EventSenderService {

  constructor(
    private instanceService: InstanceService,
    private offlineImageService: OfflineImageService,
    private onlineImageService: OnlineImageService,
    private onlineTimerService: OnlineTimerService,
    private testAvatarsService: TestAvatarsService,
    private testSpiralMakerService: TestSpiralMakerService,
    private surfaceGridTestService: SurfaceGridTestService,
    private isolateService: IsolateEntityService,
    private store: Store,
  ) {
    this.store.select(selectWorldReady).subscribe((binstViewReady: boolean) => {
      if (!binstViewReady) {
        return;
      }
      this.store
        .select(routeSelectors.selectQueryParam("debug"))
        .subscribe((params) => {
          if (!params) return;
          if (params.includes("*")) {
              console.log("debug * mode enabled")
            this.store.dispatch(
              worldActions.surfaceDebuggingToggled({ enabled: true }),
            );
          }
          if (params.includes("surface")) {
              console.log("debug surface mode enabled")
            this.store.dispatch(
              worldActions.surfaceDebuggingToggled({ enabled: true }),
            );
          }
        });
        this.store
          .select(routeSelectors.selectQueryParam("test"))
          .subscribe((params) => {
            if (!params) return;
            const tests: EventsBlueprint[] = [
              offlineImageService,
              onlineImageService,
              onlineTimerService,
              testAvatarsService,
              testSpiralMakerService,
                surfaceGridTestService
            ]
            for (let testService of tests) {
              if (params === testService.prompt) {
                testService.start()
              }
            }
        });
    });
  }

  log(data: string) {
    if (true) {
      console.log(data);
    }
  }



}
